<template>
    <editor
        api-key="no-api-key"
        :init="{
         height: 300,
         width: '100%',
         menubar: false,
         content_css: '/css/tinymce.css',
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         toolbar:
           'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help'
       }"
    />
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Editor from '@tinymce/tinymce-vue'

@Options({
    name:'NextEditor',
    components: {
        Editor,
    },
})
export default class NextEditor extends Vue {

}

</script>

<style lang="scss">

</style>
